<template>
  <div>
    <h1>SHOPPING AT BRANDED HACKTHINGS</h1>
    <product-list/>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

import ProductList from '../components/ProductList.vue'
export default {
  name: 'Home',
  components: {
    ProductList
  }
}
</script>

<style>
h1{
  font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
}
</style>
